/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TableX from 'DesignSystem/TableX/react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Treatment/Content/Actions/Content/Questionnaires/Content/Content/QuestionsAnswersModal/Content/Content"
  
}) {
let questionsValueData = fromData.useDataFormat({ viewPath,
context: 'questions',
format: fromHelpers.tableDataQuestions,
})
  return (<React.Fragment
>
<TableX
  viewPath={`${viewPath}/TableX`}
 data="questions"
 format="helpers.js tableDataQuestions"
 value={questionsValueData}
 heightHeader={48}
 heightRow={48}
/>
{children}
</React.Fragment>)
}